import script from "./BookingSummaryDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingSummaryDisplay.vue?vue&type=script&setup=true&lang=js"

import "./BookingSummaryDisplay.vue?vue&type=style&index=0&id=5db56246&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db56246"]])

export default __exports__